// extracted by mini-css-extract-plugin
export default {"rowsBtn":"TableParams_rowsBtn__hzcbv","modalHead":"TableParams_modalHead__UO-r4","formCheck":"TableParams_formCheck__+BISl"};